export default {
  recentActivity: 'Recommended',
  mightInterested: 'You might be interested',
}